export const GET_DEVICE_GROUP = "V3_GET_DEVICE_GROUP";
export const GET_DEVICE_GROUPS = "V3_GET_DEVICE_GROUPS";
export const GET_DEVICES_BY_DEVICE_GROUP_RELATION = "V3_GET_DEVICES_BY_DEVICE_GROUP_RELATION";